import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import dataService from 'api/dataService';
import { getData, dataReceived } from 'datahub/actions';
import {
  setSearch,
  setMunicipality,
  setCategories,
  setPublishedDates,
  setDocumentTypes,
  setDocumentSources
} from 'filters/actions';
import { filterData, resetCategories } from 'filters/selectors';
import { Text, OutlineButton } from 'components/styled/ui';
import { images, strings } from 'config';

class NoData extends Component {
  resetFilters = () => {
    const { filters, handleFilters } = this.props;

    const initialCategories = resetCategories(filters.categories);

    const filteredResult = {
      ...filters,
      ...{
        categories: initialCategories,
        publishedDates: [],
        documentTypes: [],
        documentSources: [],
        municipality: {
          id: '',
          name: 'सबै स्थानिय सरकारहरु',
          nameEn: 'All Municipalities'
        },
        search: '',
        page: 1
      }
    };
    handleFilters(filteredResult);
    this.props.history.push('/');
  };

  resetFiltersExcludeMun = () => {
    const { filters, handleFilters } = this.props;

    const initialCategories = resetCategories(filters.categories);

    const filteredResult = {
      ...filters,
      ...{
        categories: initialCategories,
        publishedDates: [],
        documentTypes: [],
        documentSources: [],
        search: '',
        page: 1
      }
    };
    handleFilters(filteredResult);
    this.props.history.push('/');
  };

  renderOutlineButton() {
    const { type, filters, originalData } = this.props;
    const selectedMunId = filters.municipality.id;

    const hasFilteredMunData = originalData.filter((val, index) => val.mpc_id === selectedMunId);

    if (filters.municipality.id && hasFilteredMunData.length > 0) {
      return (
        <OutlineButton onClick={this.resetFiltersExcludeMun}>{strings.noData.reset}</OutlineButton>
      );
    } else {
      return (
        <Fragment>
          {type !== 'detail' && (
            <OutlineButton onClick={this.resetFilters}>
              {selectedMunId ? strings.noData.showFor : strings.noData.reset}
            </OutlineButton>
          )}
        </Fragment>
      );
    }
  }

  render() {
    const { type } = this.props;

    return (
      <NoDataWrap>
        <img className="icon" src={images.icons.noData} alt="No Data" />

        {type !== 'detail' ? (
          <Text className="text" size={16} align="center">
            {strings.noData.noDocument}
          </Text>
        ) : (
          <Text className="text" size={16} align="center">
            {strings.noData.noDetail}
          </Text>
        )}

        {this.renderOutlineButton()}
      </NoDataWrap>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters,
    originalData: state.datahub.originalData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleFilters: filters => {
      dispatch(setSearch(filters.search));
      dispatch(setCategories(filters.categories));
      dispatch(setPublishedDates(filters.publishedDates));
      dispatch(setDocumentTypes(filters.documentTypes));
      dispatch(setMunicipality(filters.municipality));
      dispatch(setDocumentSources(filters.documentSources));
      const queryParams = filterData(filters);
      dispatch(getData());
      dataService.getDataList(queryParams).then(response => {
        dispatch(dataReceived(response));
      });
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NoData));

const NoDataWrap = styled.div`
  text-align: center;

  .icon {
    margin-bottom: 8px;
  }

  .text {
    color: #adadad;
    margin-bottom: 24px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/noData/noData.js